var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NotificationDialog',{attrs:{"fragment-boxes":_vm.fragmentBoxes,"url":_vm.notificationURL,"principals":_vm.principals},scopedSlots:_vm._u([{key:"activator",fn:function(activatorProps){return [_vm._t("activator",null,null,activatorProps)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }